import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Spinner from "../Reusable/Spinner";
import { useRef } from "react";

const CreateBranchForm = (props: any) => {
  const { handleCreate, isLoading, data, loading, user, setError } = props;
  const debounceRef = useRef(false);
  const handleGenerateClick = () => {
    if (debounceRef.current) return;
    debounceRef.current = true;
    handleCreate(user, setError);
    setTimeout(() => {
      debounceRef.current = false;
    }, 2000);
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="flex justify-between mt-8">
            <div>Total Number of order:</div>
            <div>{data?.total_order}</div>
          </div>
          <div className="flex justify-between mt-2">
            <div>Total Number of Pickups:</div>
            <div>{data?.pickup}</div>
          </div>
          <div className="flex justify-between mt-2">
            <div>Total COD:</div>
            <div>{data?.merchant_cod}</div>
          </div>
          <div className="flex justify-between mt-2">
            <div>Total Collected COD:</div>
            <div>{data?.collected_cod}</div>
          </div>
          <div className="flex justify-between mt-2">
            <div>Commision:</div>
            <div>{data?.commission}</div>
          </div>
          <div className="flex justify-between mt-2">
            <div>Advances:</div>
            <div>{data?.advances ?? 0.0}</div>
          </div>
          <div className="flex justify-between mt-2 font-bold">
            <div>Net Payable</div>
            <div>{data?.payable_amount}</div>
          </div>
          <div className={tw`mx-auto`}>
            <div className={tw`w-40`}>
              <Button
                label={"Generate Statement"}
                isLoading={isLoading}
                onClick={handleGenerateClick}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CreateBranchForm;
